import React, { ReactElement } from 'react';

import { Grid } from '@material-ui/core';

import DeleteTitles from 'pages/titlesCM/actions/delete';
import PaginationTitles from 'pages/titlesCM/actions/paginationTitles';
import SelectStatus from 'pages/titlesCM/actions/selectStatus';
import SelectWriter from 'pages/titlesCM/actions/selectWriter';
import TransferTitles from 'pages/titlesCM/actions/transferTitles';
import { StatusType } from 'enums/status-type.enum';
import TransferDomain from 'pages/titlesCM/actions/transferDomain';
import ContentGenerator from 'pages/titlesCM/actions/contentGenerator';

interface IToolbarProps {
  selectedRows: Map<string, ITitle>;
  refetchTitles: (showBackdrop?: boolean) => void;
  permissions: IPermission;
  filterStatus: number | null;
  sitesList: string[];
  clearSelectedCheckboxes: () => void;
}

export const Toolbar = ({
  selectedRows,
  refetchTitles,
  permissions,
  filterStatus,
  sitesList,
  clearSelectedCheckboxes,
}: IToolbarProps): ReactElement => {
  return (
    <Grid
      container
      spacing={0}
      item
      alignItems="flex-start"
      justify="flex-end"
      direction="row"
    >
      <Grid item xs={1}>
        <TransferDomain selectedTitles={selectedRows} refetch={refetchTitles} />
      </Grid>
      <Grid item xs={1}>
        <SelectStatus selectedTitles={selectedRows} refetch={refetchTitles} />
      </Grid>
      <Grid item xs={1}>
        <SelectWriter
          selectedTitles={selectedRows}
          refetch={refetchTitles}
          clearSelectedCheckboxes={clearSelectedCheckboxes}
        />
      </Grid>
      <Grid item xs={1}>
        <ContentGenerator
          selectedTitles={selectedRows}
          refetch={refetchTitles}
        />
      </Grid>
      <Grid item xs={1}>
        <DeleteTitles selectedRows={selectedRows} refetch={refetchTitles} />
      </Grid>
      <Grid item xs={1}>
        <PaginationTitles
          selectedTitles={selectedRows}
          refetch={refetchTitles}
        />
      </Grid>
      {permissions?.showTransferSiteDomain &&
        filterStatus === StatusType.Published && (
          <Grid item xs={1}>
            <TransferTitles
              selectedTitles={selectedRows}
              refetch={refetchTitles}
              sitesList={sitesList}
            />
          </Grid>
        )}
    </Grid>
  );
};
